import { createContext, useContext } from 'react';
const CrudRecordContext = createContext();
export const CrudRecordProvider = CrudRecordContext.Provider;
export const useCrudRecord = () => useContext(CrudRecordContext);
